import React, {useState, useEffect} from 'react'
import styles from './styles.module.scss'
import branchApi from "../../store/branchStore/branchApi";
import ButtonFilled from "../../components/FormElements/ButtonFilled";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import { store } from "react-notifications-component";
import {useHistory} from "react-router-dom";
import TextField from "../../components/FormElements/TextField";
import MaskService from "react-masked-text/src/mask-service";
import instance from "../../api";
import {clearMask} from "../../helpers";
import AvatarImg from '../../assets/user.png'

const ClientsDatabaseSendNotificationExcludeNumber = (props) => {
  const { info } = useSelector(s => s.branchReducer);
  const history = useHistory()
  const { t, i18n } = useTranslation();
  const [phone, setPhone] = useState('');
  const [blackListPhones, setBlackListPhones] = useState([]);
  const [lookingClient, setSetLookingClient] = useState(false);
  const [pending, setPending] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const getCustomer = async () => {
    const response = await branchApi.getNotificationsExcludedUsers(info.id)
    setBlackListPhones(response.data || [])
  }

  const onFindClient = async () => {
    if (!phone || lookingClient) return

    try {
      setSetLookingClient(true);
      const client = await instance().get(`/promoters/find?phone=${clearMask(phone)}`).then(res => res.data);
      if (client) {
        setPending(true);
        branchApi
          .postNotificationsBlacklist(info.id, {phones: [clearMask(phone)]})
          .then(() => {
            getCustomer()
          })
          .finally(() => {
            setPending(false);
          })
      }
    } catch (e) {
      store.addNotification({
        title: t('error'),
        message: t('Notify.notReg'),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
    } finally {
      setSetLookingClient(false);
    }
  }

  const onDeleteUser = async (userId) => {
    if (!userId) return
    try {
      setDeleting(true);
      await branchApi.deleteNotificationsExcludedUsers(info.id, userId)
      await getCustomer()
    } catch (e) {
      store.addNotification({
        title: t('error'),
        message: t('error'),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
    } finally {
      setDeleting(false);
    }
  }

  const onChangePhone = (e) => {
    setPhone(MaskService.toMask('custom', e.target.value, {
      mask: '7 (999) 999-99-99'
    }));
  }

  useEffect(() => {
    getCustomer()
  }, [])

  return (
    <div className={styles.clients}>
      <div className={styles.secondBlock}>
        <TextField
          label={t('NSCorporative.phone')}
          placeholder="7 (707) 777-77-77"
          width="224px"
          value={phone}
          onKeyUp={(e) => e.code === 'Enter' && onFindClient()}
          onChange={onChangePhone}
        />
        <ButtonFilled disabled={pending} loading={lookingClient} className={styles['secondBlock__btn']} onClick={onFindClient}>{t('add')}</ButtonFilled>
        <p className={styles['block__text']}>{t('NSMailing.assessed')}</p>
      </div>
      {blackListPhones.length ? (
        <table className="table">
          <thead>
          <tr>
            <th>№</th>
            <th>{t('NSCorporative.phone')}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          {
            !!blackListPhones.length ? blackListPhones.map((c, index) => (
                <tr key={c.id}>
                  <td>{index + 1}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <img src={c.avatar || AvatarImg} alt={c.first_name} style={{ width: '30px', height: '30px', borderRadius: '50%', objectFit: 'contain' }}/>
                      {c.first_name} {c.last_name}
                    </div>
                  </td>
                  <td>{c.phone}</td>
                  <td style={{  paddingRight: '28px' }}>
                    <button
                      style={{ marginLeft: 'auto' }}
                      className="btn-trash"
                      type="button"
                      onClick={() => onDeleteUser(c.id)}
                      disabled={deleting}
                    >
                      <i>
                        <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.4219 1.875H8.84375V1.40625C8.84375 0.63085 8.2129 0 7.4375 0H5.5625C4.7871 0 4.15625 0.63085 4.15625 1.40625V1.875H1.57812C0.931953 1.875 0.40625 2.4007 0.40625 3.04688V4.6875C0.40625 4.94637 0.616133 5.15625 0.875 5.15625H1.13117L1.53614 13.6606C1.57191 14.4117 2.18891 15 2.94078 15H10.0592C10.8111 15 11.4281 14.4117 11.4639 13.6606L11.8688 5.15625H12.125C12.3839 5.15625 12.5938 4.94637 12.5938 4.6875V3.04688C12.5938 2.4007 12.068 1.875 11.4219 1.875ZM5.09375 1.40625C5.09375 1.14779 5.30404 0.9375 5.5625 0.9375H7.4375C7.69596 0.9375 7.90625 1.14779 7.90625 1.40625V1.875H5.09375V1.40625ZM1.34375 3.04688C1.34375 2.91765 1.4489 2.8125 1.57812 2.8125H11.4219C11.5511 2.8125 11.6562 2.91765 11.6562 3.04688V4.21875C11.5118 4.21875 1.94237 4.21875 1.34375 4.21875V3.04688ZM10.5274 13.616C10.5155 13.8664 10.3098 14.0625 10.0592 14.0625H2.94078C2.69015 14.0625 2.48448 13.8664 2.47259 13.616L2.06973 5.15625H10.9303L10.5274 13.616Z" fill="white"/>
                          <path d="M6.5 13.125C6.75887 13.125 6.96875 12.9151 6.96875 12.6562V6.5625C6.96875 6.30363 6.75887 6.09375 6.5 6.09375C6.24113 6.09375 6.03125 6.30363 6.03125 6.5625V12.6562C6.03125 12.9151 6.2411 13.125 6.5 13.125Z" fill="white"/>
                          <path d="M8.84375 13.125C9.10262 13.125 9.3125 12.9151 9.3125 12.6562V6.5625C9.3125 6.30363 9.10262 6.09375 8.84375 6.09375C8.58488 6.09375 8.375 6.30363 8.375 6.5625V12.6562C8.375 12.9151 8.58485 13.125 8.84375 13.125Z" fill="white"/>
                          <path d="M4.15625 13.125C4.41512 13.125 4.625 12.9151 4.625 12.6562V6.5625C4.625 6.30363 4.41512 6.09375 4.15625 6.09375C3.89738 6.09375 3.6875 6.30363 3.6875 6.5625V12.6562C3.6875 12.9151 3.89735 13.125 4.15625 13.125Z" fill="white"/>
                        </svg>
                      </i>
                      <span>{t('delete')}</span>
                    </button>
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            )
          }
          </tbody>
        </table>
      ) : null}
      {/*<InfiniteScroll*/}
      {/*  loadMore={hasMoreReviews ? onLoadMoreReviews : () => {}}*/}
      {/*  hasMore={hasMoreReviews}*/}
      {/*>*/}
      {/*    */}
      {/*</InfiniteScroll>*/}
    </div>
  )
}

export default ClientsDatabaseSendNotificationExcludeNumber